import { useEffect, useState } from 'react'
import { Skeleton } from '@chakra-ui/react'

import { Role } from 'Attendances/types'
import RoleCard from 'Attendances/components/RoleCard'
import { useCustomFormAnswer } from 'components/tools/CustomForm/components/Answers/contexts/CustomFormViewerQuestionManager/Provider'
import getroleOnCustomForm from './services/getRoleOnCustomForm'

export default function CustomFormAnswerRole() {
  const [loadingRole, setLoadingRole] = useState<boolean>(false)
  const [role, setrole] = useState<Role>({})

  const { answer } = useCustomFormAnswer()

  const answerValue = answer.answer ? answer.answer[0] : ''

  const roleId: string = answerValue

  async function getRole() {
    setLoadingRole(true)
    const response = await getroleOnCustomForm({ roleId })
    if (response?.header?.success) {
      const roleFromAPI = response?.body?.role
      setrole(roleFromAPI)
    }
    setLoadingRole(false)
  }

  useEffect(() => {
    if (answerValue) getRole()
  }, [answerValue])

  return (
    <Skeleton isLoaded={!loadingRole}>
      <RoleCard borderWidth="1px" borderColor="borderColor" roleInformation={role} />
    </Skeleton>
  )
}
